var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRetry = function SvgRetry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.447 1.953a.6.6 0 0 1 .6.6v5.184a.6.6 0 0 1-.01.124q-.007.025-.016.049a.6.6 0 0 1-.149.262q-.019.016-.039.03-.026.025-.054.045-.016.009-.034.017a1 1 0 0 1-.068.035q-.029.011-.057.019-.028.01-.057.017a.6.6 0 0 1-.116.012h-5.195a.6.6 0 0 1 0-1.2h3.747l-1.324-1.323v-.001c-1.771-1.698-4.124-2.671-6.578-2.671a8.75 8.75 0 1 0 8.75 8.751.6.6 0 1 1 1.2 0 9.953 9.953 0 0 1-11.892 9.76A9.952 9.952 0 0 1 6.568 3.63a9.95 9.95 0 0 1 5.529-1.677c2.604 0 5.097.968 7.038 2.665l.38.348.008.01 1.324 1.322V2.552a.6.6 0 0 1 .6-.6"
  })));
};
export default SvgRetry;